import Quiz from './pages/Public/Quiz';
import DonationReturn from './pages/Public/DonationReturn';
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { useAuth } from './contexts/AuthContext';

// Layouts
import MainLayout from './components/Layout/MainLayout';
import AuthLayout from './components/Layout/AuthLayout';

// Pages
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Subscribers from './pages/Subscribers/Subscribers';
import SubscriberDetail from './pages/Subscribers/SubscriberDetail';
import Proverbs from './pages/Proverbs/Proverbs';
import Ephemerides from './pages/Ephemerides/Ephemerides';
import EphemerisPreview from './pages/Ephemerides/EphemerisPreview';
import WhatsAppMessages from './pages/WhatsApp/WhatsAppMessages';
import WhatsAppConfig from './pages/WhatsApp/WhatsAppConfig';
import AdminResend from './pages/WhatsApp/AdminResend';
import Broadcast from './pages/WhatsApp/Broadcast';
import Statistics from './pages/Stats/Statistics';
import AudioRecorder from './pages/Audio/AudioRecorder';
import Sponsors from './pages/Sponsors/Sponsors';
import Donations from './pages/Donations/Donations';
import IncomingMessages from './pages/WhatsApp/IncomingMessages';
import Validation from './pages/Dictionary/Validation';
import Users from './pages/Users/Users';
import Settings from './pages/Settings/Settings';
import Subscribe from './pages/Public/Subscribe';
import Dictionary from './pages/Public/Dictionary';
import DailyEphemeris from './pages/Public/DailyEphemeris';
import DualaEditor from './pages/Public/DualaEditor';
import PublicPortalLayout from './components/Layout/PublicPortalLayout';

// Composant de route protégée
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        Chargement...
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Le panneau admin (dashboard, abonnés, WhatsApp, paramètres...) est
  // réservé à admin/super_admin. Un relecteur n'a droit qu'à la vérification
  // du dictionnaire, accessible depuis la page publique /dictionnaire.
  if (user?.role === 'relecteur') {
    return <Navigate to="/dictionnaire" replace />;
  }

  return children;
};

function App() {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/login" element={
        <AuthLayout>
          <Login />
        </AuthLayout>
      } />
      
      <Route path="/" element={<PublicPortalLayout />}>
        <Route path="aujourdhui" element={<DailyEphemeris />} />
        <Route path="dictionnaire" element={<Dictionary />} />
        <Route path="quiz" element={<Quiz />} />
        <Route path="editeur" element={<DualaEditor />} />
        <Route path="subscribe" element={<Subscribe />} />
        <Route path="merci" element={<DonationReturn kind="thanks" />} />
        <Route path="don-annule" element={<DonationReturn kind="cancel" />} />
      </Route>

      {/* Routes protégées (admin) */}
      <Route path="/" element={
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="subscribers" element={<Subscribers />} />
        <Route path="subscribers/:id" element={<SubscriberDetail />} />
        <Route path="proverbs" element={<Proverbs />} />
        <Route path="ephemerides" element={<Ephemerides />} />
        <Route path="ephemerides/preview/:date" element={<EphemerisPreview />} />
        <Route path="whatsapp" element={<WhatsAppMessages />} />
        <Route path="whatsapp/config" element={<WhatsAppConfig />} />
        <Route path="whatsapp/resend" element={<AdminResend />} />
        <Route path="whatsapp/inbox" element={<IncomingMessages />} />
        <Route path="whatsapp/broadcast" element={<Broadcast />} />
        <Route path="dictionary/suggestions" element={<Navigate to="/dictionary/validation" replace />} />
        <Route path="dictionary/validation" element={<Validation />} />
        <Route path="stats" element={<Statistics />} />
        <Route path="audio" element={<AudioRecorder />} />
        <Route path="sponsors" element={<Sponsors />} />
        <Route path="donations" element={<Donations />} />
        <Route path="users" element={<Users />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      {/* Route 404 */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
